import React from "react";
import Navbar from "../components/Navbar";
import ListContainer from "../components/List/ListContainer";

const List = () => {
  return (
    <div>
      <Navbar />
      <div className="background">
        <ListContainer />
      </div>
    </div>
  );
};

export default List;
